import { ApiClient } from "#/shared/api/client";
import { extractErrorMessage } from "#ce/apps/SpAdmin/shared/utils/extract-error-message";

class RsvpInviteApi extends ApiClient {
  transform(data) {
    return data;
  }

  async preview(previewUrl, formData) {
    try {
      return await this.post(previewUrl, formData);
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }

  async process(processUrl, payload) {
    try {
      return await this.post(processUrl, payload);
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }
}

let api;

export function createRsvpInviteApi() {
  api ??= new RsvpInviteApi();

  return api;
}
